// extracted by mini-css-extract-plugin
export var logo = "_ke-2";
export var logoWrapper = "_ke-1";
export var strip = "_ke-0";